import React, { useState, useContext } from "react";
import { Col, InnerWrapper, Modal } from "../UI/general";
import { DialBtn, NumberBox, CallSection, DialIcons } from "../UI/dial";
import { css } from "styled-components/macro";
import { ModalContext } from "./../general/ModalContext";
import {
  ConfirmModalGenerator,
  ConfirmFollowUpModal
} from "./confirmStatusModals";

const Buttons = [
  { title: "تایید شد", color: "var(--success)", status: 1, order: 12 },
  { title: "کنسل شد", color: "var(--failed)", status: 2, order: 13 },
  { title: "پیگیری", color: "var(--danger)", status: 3, order: 14 },
  { title: "پاسخ نداد", color: "var(--info)", status: 4, order: 15 }
];

export default function ButtonsSection({ click }) {
  const setModal = useContext(ModalContext);
  let [hours, setHours] = useState(null);
  return (
    <>
      {Buttons.map((item, index) => (
        <Col
          key={index}
          size="25"
          style={{ order: item.order, textAlign: "center" }}
        >
          <DialBtn
            css={css`
              font-size: 14px;
              background-color: ${item.color};
              color: #fff;
              border-radius: 10px;
              line-height: 40px;
              height: 40px;
              width: 100%;
            `}
            onClick={() => {
              const button = Buttons[index];
              if (button.status === 3) {
                setModal(ConfirmFollowUpModal(button, click, hours, setHours));
              } else {
                setModal(ConfirmModalGenerator(button, click));
              }
            }}
          >
            {item.title}
          </DialBtn>
        </Col>
      ))}
    </>
  );
}
